<template>
  <v-icon class="font-weight-black"
    :color="color"
  >{{ icon }}</v-icon>
</template>

<script>

export default {
  name: 'EventIcon',
  props: {
    value: {
      type: String,
      required: true
    }
  },
  data: () => ({
  }),
  computed: {
    color() {
      return this.value === 'ARRIVAL' ? 'blue lighten-2' : 'purple darken-2'
    },
    icon() {
      return this.value === 'ARRIVAL' ? 'mdi-arrow-bottom-right-thick' : 'mdi-arrow-top-right-thick'
    }
  },
  methods: {
  }
}
</script>
